import React from 'react';
import { Flex } from '@knockrentals/knock-shared-web-v2';
import {
  ErrorDialog,
  LoadingOverlay,
  PageContainer,
  PageHeader,
} from '../../../knock-design-system';
import { HeaderActions } from './HeaderActions';
import { PropertiesDialog } from './PropertiesDialog';
import { PropertyList } from './PropertyList';
import { PropertyTabs } from './PropertyTabs';
import { useProperties } from './use-properties';

export const TITLE = 'Properties';
export const DESCRIPTION =
  'Manage community info for listing services and your Leasing Binder, and configure advanced property settings.';

const PropertiesPage = () => {
  const {
    closeErrorDialog,
    closePropertiesDialog,
    handleSetPropertiesDialogMode,
    isLoadingPropertiesList,
    isLoadingProperty,
    isUpdatingProperty,
    propertiesDialogConfig,
    propertiesDialogMode,
    propertiesList,
    propertiesListErrorMessage,
    property,
    propertyCreateErrorMessage,
    propertyErrorMessage,
    propertyUpdateErrorMessage,
    selectedPropertyId,
    setSelectedPropertyId,
    updateProperty,
  } = useProperties();

  const isLoadingOverlayOpen =
    isLoadingProperty || isLoadingPropertiesList || isUpdatingProperty;

  const errorDialogMessage =
    propertyCreateErrorMessage || propertyUpdateErrorMessage;

  const isTransferPropertyDisabled =
    !isLoadingOverlayOpen && !property.propertyId;

  return (
    <PageContainer className="properties-page">
      <PageHeader title={TITLE} description={DESCRIPTION}>
        <HeaderActions
          isTransferPropertyDisabled={isTransferPropertyDisabled}
          setMode={handleSetPropertiesDialogMode}
        />
      </PageHeader>

      <LoadingOverlay isInvisible isOpen={isLoadingOverlayOpen} zIndex={1} />

      <ErrorDialog
        errorMessage={errorDialogMessage}
        closeDialog={closeErrorDialog}
      />

      <PropertiesDialog
        closeDialog={closePropertiesDialog}
        dialogMode={propertiesDialogMode}
        dialogConfig={propertiesDialogConfig}
        currentProperty={property}
      />

      <Flex flex={1} gap={20} overflow="hidden" paddingTop="24px">
        <PropertyList
          errorMessage={propertiesListErrorMessage}
          isLoading={isLoadingPropertiesList}
          properties={propertiesList}
          selectedPropertyId={selectedPropertyId}
          setSelectedPropertyId={setSelectedPropertyId}
        />

        <PropertyTabs
          errorMessage={propertyErrorMessage}
          isLoading={isLoadingProperty || isLoadingPropertiesList}
          key={selectedPropertyId}
          property={property}
          updateProperty={updateProperty}
        />
      </Flex>
    </PageContainer>
  );
};

export default PropertiesPage;
